import img1 from '../images/pubjab/Screenshot 2022-12-28 at 01.38.34.webp';
import img2 from '../images/pubjab/Screenshot 2022-12-28 at 01.39.04.webp';
import img3 from '../images/pubjab/Screenshot 2022-12-28 at 01.39.45.webp';
import img4 from '../images/pubjab/Screenshot 2022-12-28 at 01.40.09.webp';

export const punjabImages = [img1, img2, img3, img4];
